// EmployeeListAttendance.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrashAlt,
  faUserPen,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import { viewerDisabledProps } from "../utils/permissions";
const EmployeeListAttendanceTest = () => {
  const [employees, setEmployees] = useState([]);
  const [initialEmployees, setInitialEmployees] = useState([]);
  const [searchField, setSearchField] = useState("emp_name");
  const [searchTerm, setSearchTerm] = useState("");
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [attendanceData, setAttendanceData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(
        `https://ims-attendanceback.indevconsultancy.in/api/attendance-detail-master/`
      )
      .then((response) => {
        console.log(response.data);
        if (response.data) {
          setEmployees(response.data);
          setInitialEmployees(response.data.employees);
        }
      })
      .catch((error) => {
        console.error("Error fetching employee data:", error);
      });
  }, []);

  useEffect(() => {
    fetchAttendance();
  }, [month]);

  const fetchAttendance = async () => {
    // TODO: Replace this with actual API
    // Demo data for example
    const sampleData = [
      { id: 1, emp_name: "John Doe", status: "present", date: "2025-06-10" },
      { id: 2, emp_name: "Jane Smith", status: "absent", date: "2025-06-12" },
      { id: 1, emp_name: "John Doe", status: "present", date: "2025-06-15" },
    ];
    const filtered = sampleData.filter((d) => d.date.startsWith(month));
    setAttendanceData(filtered);
  };

  const handleEdit = (id) => {
    alert(`Edit employee with ID: ${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this employee?")) {
      const updated = employees.filter((emp) => emp.id !== id);
      setEmployees(updated);
      setInitialEmployees(updated);
    }
  };
  const convertToIndianTime = (utcString) => {
    const date = new Date(utcString);
    const options = {
      timeZone: "Asia/Kolkata",
      hour12: false,
    };
    const indianTime = date.toLocaleString("en-GB", options);
    const [ddmmYYYY, time] = indianTime.split(", ");
    const [dd, mm, yyyy] = ddmmYYYY.split("/");
    return `${yyyy}-${mm}-${dd} ${time}`;
  };
  const handleSearch = () => {
    const filtered = initialEmployees.filter((emp) =>
      (emp[searchField] || "")
        .toString()
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
    setEmployees(filtered);
    setCurrentPage(1);
  };

  const handleReset = () => {
    setSearchTerm("");
    setEmployees(initialEmployees);
    setCurrentPage(1);
  };

  const exportToExcel = () => {
    const data = employees.map((emp) => {
      const statusForMonth = attendanceData.filter(
        (a) => a.emp_name === emp.emp_name
      );
      const presentDays = statusForMonth.filter(
        (a) => a.status === "present"
      ).length;
      const absentDays = statusForMonth.filter(
        (a) => a.status === "absent"
      ).length;

      return {
        Name: emp.emp_name,
        Mobile: emp.emp_mobile_no,
        Month: month,
        "Present Days": presentDays,
        "Absent Days": absentDays,
      };
    });
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");
    XLSX.writeFile(workbook, `Attendance_Report_${month}.xlsx`);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = employees.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(employees.length / itemsPerPage);

  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="px-3 py-3 bg-cream" style={{ minHeight: "100%" }}>
      <div className="card">
        <div className="card-header bg-skyBlue text-white">
          <h5 className="mb-0">Employee List</h5>
        </div>
        <div className="card-body">
          <div className="row g-2 g-md-3 align-items-center mb-3">
            <div className="col-12 col-md-3">
              <select
                className="form-select"
                value={searchField}
                onChange={(e) => setSearchField(e.target.value)}
              >
                <option value="emp_name">Employee Name</option>
                <option value="father_name">Father Name</option>
                <option value="emp_mobile_no">Mobile</option>
              </select>
            </div>
            <div className="col-12 col-md-5">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-6 col-md-2">
              <button className="btn btn-primary w-100" onClick={handleSearch}>
                Search
              </button>
            </div>
            <div className="col-6 col-md-2">
              <button className="btn btn-secondary w-100" onClick={handleReset}>
                Reset
              </button>
            </div>
          </div>

          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
            <h6 className="mb-0 text-nowrap">
              Total Employees: <strong>{employees.length}</strong>
            </h6>

            <div className="d-flex flex-column flex-sm-row gap-2 w-100 justify-content-sm-end mt-2 mt-md-0">
              <input
                type="month"
                className="form-control w-100 w-sm-auto"
                style={{ minWidth: "160px" }}
                value={month}
                onChange={(e) => setMonth(e.target.value)}
              />
              <button
                className="btn btn-success text-nowrap"
                onClick={exportToExcel}
              >
                Export Excel
              </button>
              <button
                className="btn btn-success text-nowrap"
                onClick={() => navigate("/add-employee-bulk")}
                    {...viewerDisabledProps()}
              >
                Bulk Upload
              </button>
              <button
                className="btn btn-primary bg-skyBlue text-nowrap"
                onClick={() => navigate("/employeeForm")}
                    {...viewerDisabledProps()}
              >
                Add Employee
              </button>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered table-striped text-center">
              <thead className="table-light">
                <tr>
                  <th>S.No</th>
                  <th>Employee Name</th>
                  <th>Employee Code</th>
                  <th>Entry Time</th>
                  <th>Exit Time</th>
                  <th>Entry Image</th>
                  <th>Exit Image</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="9">No employees found.</td>
                  </tr>
                ) : (
                  currentItems.map((emp, index) => {
                    const statusForEmployee = attendanceData.filter(
                      (a) => a.emp_name === emp.emp_name
                    );
                    const presentDays = statusForEmployee.filter(
                      (a) => a.status === "present"
                    ).length;
                    const absentDays = statusForEmployee.filter(
                      (a) => a.status === "absent"
                    ).length;

                    return (
                      <tr key={emp.id}>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>{emp.emp_name}</td>
                        <td>{emp.emp_code || "-"}</td>
                        <td>{emp.entry_time ? convertToIndianTime(emp.entry_time) : '-'}</td>
                        <td>{emp.exit_time ? convertToIndianTime(emp.exit_time) : '-'}</td>
                        <td><img src={emp.entryimage} alt="" srcset="" height="40px" width="60px" /></td>
                        <td><img src={emp.exitimage} alt="" srcset="" height="40px" width="60px" /></td>
                        <td>
                          <button
                            className="btn btn-sm btn-info text-white"
                            onClick={() =>
                              navigate("/employeeDetails", {
                                state: { employee: emp },
                              })
                            }
                          >
                            <FontAwesomeIcon icon={faEye} />
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>

            <nav
              className="mt-3 d-flex justify-content-center"
              aria-label="Pagination"
            >
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => changePage(currentPage - 1)}
                  >
                    Previous
                  </button>
                </li>
                {[...Array(totalPages)].map((_, i) => (
                  <li
                    key={i}
                    className={`page-item ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => changePage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => changePage(currentPage + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div className="card-footer text-muted text-center small">
          Technology Partner: Indev Consultancy ©2025
        </div>
      </div>
    </div>
  );
};

export default EmployeeListAttendanceTest;
